import React from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Greetings = (
    {
        setShowModalNuevo,
        //showModalNuevo,
        //showModalDatosFiscales, 
        setShowModalDatosFiscales
    }
) => {
    return (
        <>
        <Card className="mb-1 p-2">
            <Row className="g-2 align-items-center d-flex">
                {/*<Col xs="auto">*/}
                {/*    <img src="/img/ordenes96.png" alt="connectCircle" height={30} />*/}
                {/*</Col>*/}
                <Col>
                    <h5 className="mb-0 ">Lista de datos fiscales</h5>
                </Col>
                <Col sm="auto" className="ms-auto">
                    <Button
                        size="sm"
                        variant="falcon-primary"
                        onClick={() => {
                            setShowModalNuevo(true);
                            setShowModalDatosFiscales(true);
                        }}
                    >
                        Nuevo Dato Fiscal
                    </Button>
                </Col>
            </Row>
        </Card>
        </>
    );
};

Greetings.propTypes = {

    setShowModalNuevo: PropTypes.func,
    //showModalNuevo: PropTypes.bool,
    setShowModalDatosFiscales: PropTypes.func
};

export default Greetings;
